const get = (key: string) => {
  // @ts-ignore
  return (window._env ?? {})[key] ?? process.env[key] ?? "";
};

const env = {
  api: {
    baseUrl: {
      tokenBaseUrl: get("REACT_APP_TOKEN_BASE_URL"),
      identityService: get("REACT_APP_IDENTITY_SERVICE_BASE_URL"),
      walletService: get("REACT_APP_WALLET_SERVICE_BASE_URL"),
      membershipService: get("REACT_APP_MEMBERSHIP_SERVICE_BASE_URL"),
      dataLoaderService: get("REACT_APP_DATA_LOADER_SERVICE_BASE_URL"),
      approvalProcessorService: get(
        "REACT_APP_APPROVAL_PROCESSOR_SERVICE_BASE_URL"
      ),
      approvalRuleService: get("REACT_APP_APPROVAL_RULE_SERVICE_BASE_URL"),
      documentRepositoryService: get(
        "REACT_APP_DOCUMENT_REPOSITORY_SERVICE_BASE_URL"
      ),
      auditService: get("REACT_APP_AUDIT_SERVICE_BASE_URL"),
      disburseService: get("REACT_APP_DISBURSE_SERVICE_BASE_URL"),
      cryptographyService: get("REACT_APP_CRYPTOGRAPHY_SERVICE_BASE_URL"),
      fileValidationService: get("REACT_APP_FILE_VALIDATION_SERVICE_BASE_URL"),
    },
    uploadFolderPath: get("REACT_APP_UPLOAD_FOLDER_PATH"),
    clientId: get("REACT_APP_CLIENT_ID"),
    clientSecret: get("REACT_APP_CLIENT_SECRET"),
    tenantDomain: get("REACT_APP_TENANT_DOMAIN"),
    payrollTemplateFileUrl: get("REACT_APP_PAYROLL_TEMPLATE_FILE_URL"),
    countryCode: get("REACT_APP_COUNTRY_CODE"),
    approvalCategoryCode: get("REACT_APP_APPROVAL_CATEGORY_CODE"),
    approvalCategoryCodePSP: get("REACT_APP_APPROVAL_CATEGORY_CODE_PSP"),
  },
  app: {
    appName: get("REACT_APP_NAME"),
    rootUrl: get("REACT_APP_ROOT_URL"),
    billerRef: get("REACT_APP_BILLER_REF"),
    dakkoCompanyCode: get("REACT_APP_DAKKO_COMPANY_CODE"),
    b2bPortalRole: get("REACT_APP_B2BPORTAL_ROLES"),
    paymentOptsRole: get("REACT_APP_PAYMENT_OPTS_ROLES"),
    b2bPortalAdminRole: get("REACT_APP_B2BPORTAL_ADMIN_ROLES"),
    b2bPortalApproverRole: get("REACT_APP_B2BPORTAL_APPROVER_ROLES"),
    b2bPortalBUApproverRole: get("REACT_APP_B2BPORTAL_BU_APPROVER_ROLES"),
    b2bPortalPSPRole: get("REACT_APP_B2BPORTAL_PSP_ROLES"),
    authCodeEnabled: get("REACT_APP_AUTH_CODE_ENABLED"),
    authResourceOwner: get("REACT_APP_AUTH_RESOURCE_OWNER"),
    authCodeAppId: get("REACT_APP_AUTH_CODE_APPID"),
    authCodeClientId: get("REACT_APP_AUTH_CODE_CLIENT_ID"),
    authCodeClientSecret: get("REACT_APP_AUTH_CODE_CLIENT_SECRET"),
    configurationMinUsers: get("REACT_APP_CONFIGURATION_MIN_USERS"),
    configurationMaxUsers: get("REACT_APP_CONFIGURATION_MAX_USERS"),
    payrollManagedInHouseHR: get("REACT_APP_PAYROLL_MANAGED_INHOUSE_HR"),
    payrollManagedPSP: get("REACT_APP_PAYROLL_MANAGED_PSP"),
    payrollManagedSharedService: get(
      "REACT_APP_PAYROLL_MANAGED_SHARED_SERVICE"
    ),
    payrollManagedCustomKey: get("REACT_APP_PAYROLL_MANAGED_CUSTOM_KEY"),
    payrollEntityId: get("REACT_APP_PAYROLL_ENTITY_ID"),
  },
  featureFlags: {
    disbursementFeature: get("REACT_APP_DISBURSEMENT_FEATURE") === "true",
    fileProcessingValidation: get("REACT_APP_FILE_PROCESSING_VALIDATION") === "true",
    cryptographyIntegration: get("REACT_APP_CRYPTOGRAPHY_INTEGRATION") === "true",
    // Add more feature flags here as needed
    // Example: newUI: get("REACT_APP_NEW_UI_FEATURE") === "true",
  },
  polling: {
    fileUploadInterval: get("REACT_APP_FILE_UPLOAD_POLLING_INTERVAL"),
    tokenRefreshInterval: get("REACT_APP_TOKEN_REFRESH_INTERVAL") || "1800000", // Default: 30 minutes
  },
};

export default env;
